import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Users, Globe2, Zap } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const STATS = [["12+", "Years of Expertise"], ["250K+", "Items Certified"], ["50K+", "Certs Issued"], ["99.9%", "Verification Accuracy"]];
const PILLARS = [
  { icon: ShieldCheck, t: "Integrity First", d: "Every grade is assigned with uncompromising honesty and consistency — no shortcuts, no favors." },
  { icon: Users, t: "Expert Team", d: "Certified specialists with years of experience across sports, TCG, and entertainment collectibles." },
  { icon: Globe2, t: "Global Reputation", d: "Recognized and trusted by collectors, dealers, and auction houses worldwide." },
  { icon: Zap, t: "Fast & Reliable", d: "Efficient turnaround without ever compromising accuracy or care for your cards." },
];

export default function About() {
  return (
    <div className="bg-white" data-testid="about-page">
      <Seo title="About MAS Grading — Trading Card Grading Service" description="MAS Grading is a professional trading card grading service from MAS Certified, Inc. — accurate, consistent grades and verifiable certification trusted by collectors, dealers, and auction houses." path="/about" />
      <PageHeader eyebrow="About MAS Grading" title="Your #1 trusted source for trading card grading" subtitle="MAS Grading is the sister service to MAS Certified, Inc. — the leading, most trusted name in collectible certification. We deliver accurate, reliable, and thorough grading for collectors, investors, and enthusiasts." />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map(([k, v]) => (
            <div key={v}>
              <div className="font-display font-900 text-4xl md:text-5xl text-[#0A0A0A]" style={{ fontWeight: 900 }}>{k}</div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-neutral-400 mt-2 font-semibold">{v}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="bg-[#FAFAFA] border-y border-neutral-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400">Why choose MAS</span>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight mt-4 text-[#0A0A0A] max-w-2xl">Built on trust & precision</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
            {PILLARS.map((p) => (
              <div key={p.t} className="rounded-3xl border border-neutral-200 bg-white p-7">
                <p.icon className="text-[#0A0A0A] mb-5" size={26} />
                <h3 className="font-display font-bold text-xl text-[#0A0A0A]">{p.t}</h3>
                <p className="text-neutral-500 text-sm mt-2 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 text-center">
        <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">Ready to certify your collection?</h2>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Link to="/submit" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0A0A0A] text-white font-bold rounded-full hover:bg-neutral-800 transition-colors duration-300">Submit an Item <ArrowRight size={16} /></Link>
          <Link to="/lookup" className="inline-flex items-center gap-2 px-8 py-4 border border-neutral-300 text-[#0A0A0A] font-bold rounded-full hover:border-[#0A0A0A] transition-colors duration-300">Verify a Cert</Link>
        </div>
      </section>
    </div>
  );
}
